import Link from "@vfuk/core-link";
import { useTranslation } from "react-i18next";
import { FloatingLabelInput, Stack } from "@ucchub/ui";
import { useEffect, useRef } from "react";

interface LoginFormProps {
  email: string;
  onEmail: (e: string) => void;
  password: string;
  onPassword: (e: string) => void;
  onForgot: () => void;
}

const LoginForm = ({
  email,
  onEmail,
  password,
  onPassword,
  onForgot,
}: LoginFormProps) => {
  const { t } = useTranslation();

  // Focus the Email Input element on initial load.
  const emailFieldRef = useRef<HTMLInputElement>(null);
  useEffect(() => emailFieldRef.current?.focus(), []);

  return (
    <div>
      <FloatingLabelInput
        spaceForError={false}
        label={t("core:auth:username")}
        type="email"
        value={email}
        id="email"
        onChange={(e) => onEmail(e.target.value)}
        autoComplete="email"
        domRef={emailFieldRef}
      />

      <br />
      <FloatingLabelInput
        spaceForError={false}
        label={t("core:auth:password")}
        type="password"
        autoComplete="current-password"
        value={password}
        id="password"
        onChange={(e) => onPassword(e.target.value)}
      />

      <Stack justifyContent="end">
        <Link onClick={onForgot} showUnderline text="Forgot password?" />
      </Stack>
    </div>
  );
};

export default LoginForm;
